import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSave, faPlus } from '@fortawesome/free-solid-svg-icons';
import './AccountModal.css';

const AccountModal = ({ 
  isOpen, 
  onClose, 
  onSave, 
  account = null, 
  title,
  accountNameLabel,
  isLoading = false 
}) => {
  const [accountName, setAccountName] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (account) {
      setAccountName(account.expenseAccountName || account.payableAccName || '');
    } else {
      setAccountName('');
    }
    setErrors({});
  }, [account, isOpen]);

  const validateForm = () => {
    const newErrors = {};
    
    if (!accountName.trim()) {
      newErrors.accountName = 'Account name is required';
    } else if (accountName.trim().length < 2) {
      newErrors.accountName = 'Account name must be at least 2 characters';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onSave(accountName.trim());
    }
  };

  const handleClose = () => {
    setAccountName('');
    setErrors({});
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">
            <FontAwesomeIcon 
              icon={account ? faSave : faPlus} 
              className="modal-icon" 
            />
            {title}
          </h3>
          <button 
            className="modal-close-btn" 
            onClick={handleClose}
            disabled={isLoading}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="accountName" className="form-label">
              {accountNameLabel}
            </label>
            <input
              type="text"
              id="accountName"
              value={accountName}
              onChange={(e) => setAccountName(e.target.value)}
              className={`form-input ${errors.accountName ? 'error' : ''}`}
              placeholder={`Enter ${accountNameLabel.toLowerCase()}`}
              disabled={isLoading}
              autoFocus
            />
            {errors.accountName && (
              <span className="error-message">{errors.accountName}</span>
            )}
          </div>

          <div className="modal-actions">
            <button
              type="button"
              onClick={handleClose}
              className="btn btn-secondary"
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={isLoading || !accountName.trim()}
            >
              {isLoading ? (
                <>
                  <span className="loading-spinner"></span>
                  {account ? 'Updating...' : 'Creating...'}
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={account ? faSave : faPlus} />
                  {account ? 'Update' : 'Create'}
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AccountModal;